import { Component } from '@angular/core'

@Component({
  selector: 'se-po-membership-list-docs',
  templateUrl: './membership-list-docs.component.html',
  styleUrls: ['./membership-list-docs.component.scss'],
  standalone: false,
})
export class MembershipListDocsComponent {}
